import { db } from '../helpers/firebase'
import { serializeImage } from '../helpers/storage'
import firebase from 'firebase/app'
import 'firebase/firestore'
const channels = 'channels'
const pages = 'pages'

const Persist = {
  methods: {
    // Channel
    ChannelUpdate (id, data, callback) {
      db.collection(channels)
        .doc(id)
        .update(data).then(()=> {
          if (callback) callback()
        })
    },
    // Pages
    PagesCreate (channel_id, callback) {
      db.collection(channels)
        .doc(channel_id)
        .collection(pages)
        .add({
          title: 'Untitled'
        })
        .then((data) => {
          return callback(data.id)
        })
    },
    // Pages
    PagesCreateCustom (channel_id, content, callback) {
      db.collection(channels)
        .doc(channel_id)
        .collection(pages)
        .add(content)
        .then((data) => {
          return callback(data.id)
        })
    },
    PagesUpdate (channel_id, page_id, content, callback) {
      db.collection(channels)
        .doc(channel_id)
        .collection(pages)
        .doc(page_id)
        .update(content)
        .then((data) => {
          if (!callback) return
          return callback(data)
        })
    },
    PagesDelete (channel_id, page_id, callback) {
      db.collection(channels)
        .doc(channel_id)
        .collection(pages)
        .doc(page_id)
        .delete()
        .then((data) => {
          if (!callback) return
          return callback(data)
        })
    },
    PagesAddChild(channel_id, page_id, id, callback) {
      db.collection(channels)
      .doc(channel_id)
      .collection(pages)
      .doc(page_id)
      .update({
        children: firebase.firestore.FieldValue.arrayUnion(id)
      })
      .then((data) => {
        if (!callback) return
        return callback(data)
      })
    },
    PagesSaveBlock (channel_id, page_id, data, callback) {
      // images come through the data as a formatted firebase
      // URI - like this:
      // https://firebasestorage.googleapis.com/v0/b/fanfolk-dev.appspot.com/o/channels%2Fhiworld%2F5z8qqthE8baF0p3HW3Ty%2Fhi.jpg?alt=media&amp;token=ef3eecdd-088b-4a77-8e21-bd5dce012975"
      // we want to save just the image path, in this case:
      // /channels/hiworld/2F5z8qqthE8baF0p3HW3Ty/hi.jpg
      data.blocks = data.blocks.map((block) => {
        if (block.type == 'image' && block.data.file && block.data.file.url) {
          block.data.file.url = serializeImage(block.data.file.url)
        }

        return block
      })

      db.collection(channels)
        .doc(channel_id)
        .collection(pages)
        .doc(page_id)
        .update({
          content: data
        })
        .then((d) => {
          if (callback) return callback(d)
        })
    },
    PagesSaveContent (channel_id, page_id, data, callback) {
      // images come through the data as a formatted firebase
      // URI - like this:
      // https://firebasestorage.googleapis.com/v0/b/fanfolk-dev.appspot.com/o/channels%2Fhiworld%2F5z8qqthE8baF0p3HW3Ty%2Fhi.jpg?alt=media&amp;token=ef3eecdd-088b-4a77-8e21-bd5dce012975"
      // we want to save just the image path, in this case:
      // /channels/hiworld/2F5z8qqthE8baF0p3HW3Ty/hi.jpg
      // data.blocks = data.blocks.map((block) => {
      //   if (block.type == 'image' && block.data.file && block.data.file.url) {
      //     block.data.file.url = serializeImage(block.data.file.url)
      //   }
      //
      //   return block
      // })

      db.collection(channels)
        .doc(channel_id)
        .collection(pages)
        .doc(page_id)
        .update({
          content: data
        })
        .then((d) => {
          if (callback) return callback(d)
        })
    },
    PagesUpdateTier (channel_id, page_id, tier, callback) {
      db.collection(channels)
        .doc(channel_id)
        .collection(pages)
        .doc(page_id)
        .update({tier})
        .then((d) => {
          if (callback) return callback(d)
        })
    }
  }
}

export default Persist
